import { login, logout, getInfo, wNengKLogin } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { defineStore } from "pinia";

function readUserInfoFromStorage() {
  try {
    const raw = sessionStorage.getItem("userInfo");
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

const useUserStore = defineStore("user", {
  state: () => ({
    token: getToken(),
    id: "",
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
    userInfo: readUserInfoFromStorage(),
  }),
  actions: {
    // 登录
    login(userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            if (res.success) {
              setToken(res.data.token);
              this.token = res.data.token;
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 登录
    wanKeylogin(userId) {
      return new Promise((resolve, reject) => {
        wNengKLogin({ userId })
          .then((res) => {
            if (res.success) {
              setToken(res.data.token);
              this.token = res.data.token;
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取用户信息
    getInfo() {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            if (res.success) {
              this.setUserInfo(res.data);
            }
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setUserInfo(userInfo) {
      this.userInfo = userInfo || {};
      if (userInfo && Object.keys(userInfo).length) {
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
    },
    // 退出系统
    logOut() {
      return new Promise((resolve, reject) => {
        logout(this.token)
          .then(() => {
            console.log("退出系统");
            this.token = "";
            this.roles = [];
            this.permissions = [];
            sessionStorage.clear()
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
});

export default useUserStore;
